import AbstractMark from './AbstractMark';
import {isMarkActive} from '../helper/isMarkActive';

export default class Label extends AbstractMark {
    get name() {
        return "label";
    }

    get schema() {
        return {
            attrs: {
              color: {default: ''},
            },
            parseDOM: [{
              tag: '.ui.label', getAttrs: dom => ({
                color: dom.getAttribute("data-color")
              })
            }],
            toDOM: node => ["span", {
              class: `ui label${node.attrs.color ? ` ${node.attrs.color}` : ''}`,
              ['data-color']: node.attrs.color
            }, 0]
        }
    }

    get toMarkdown() {
      return {
        open: function open(_state, _mark) {
          const color = _mark.attrs.color;
          return `<span class="ui label${color ? ` ${color}` : ''}"${color ? ` data-color="${color}"` : ''}>`
        },
        close: "</span>",
        mixable: true,
        expelEnclosingWhitespace: true
      }
    }

    keys({type}) {
      return {
        ArrowRight: (state, dispatch) => {
          const { label } = state.schema.marks;
          const { empty, $cursor } = state.selection;
          if (!empty || !$cursor) {
            return false;
          }

          const { storedMarks } = state.tr;
          if (label) {
            const insideLabel = isMarkActive(label)(state);
            const currentPosHasLabel = state.doc.rangeHasMark(
                $cursor.pos,
                $cursor.pos,
                label
            );
            const nextPosHasLabel = state.doc.rangeHasMark(
                $cursor.pos,
                $cursor.pos + 1,
                label
            );

            const exitingLabel =
                !currentPosHasLabel &&
                !nextPosHasLabel &&
                (!storedMarks || !!storedMarks.length);

            if (insideLabel && exitingLabel) {
              dispatch(state.tr.removeStoredMark(label));

              return true;
            }
          }

          return false;
        }
      };
    }

    get parseMarkdown() {
        return {
            mark: "label", getAttrs: token => ({
              color: token.attrGet("data-color"),
            })
        };
    }
}